import * as Sentry from '@sentry/react'
import { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import clsx from 'clsx'
import './errorView.scss'

type ErrorBoundaryViewProps = {
    error: Error,
    resetErrorBoundary: () => void,
    isDialog?: boolean
}

const ErrorView : React.FC<ErrorBoundaryViewProps> = ({ error, resetErrorBoundary, isDialog }) => {
  const [sentryErrorEventId, setSentryErrorEventId] = useState<string | null>(null)

  useEffect(() => {
    const eventId = Sentry.captureException(error)
    setSentryErrorEventId(eventId)
  }, [])

  const handlerCopyError = () => {
    navigator.clipboard.writeText(JSON.stringify({
      error: error.message,
      sentryErrorEventId
    }))
  }

  return (
    <div className={clsx('error-view-container', {
      'error-view-container__is-dialog': isDialog
    })}>
      <h2 className="title">Something went wrong</h2>
      <h3 className="description">Try reloading the page.</h3>
      {sentryErrorEventId ? <h3 className="description">Error ID: {sentryErrorEventId}</h3> : null}
      <div className="btn">
        <Button
          onClick={resetErrorBoundary}
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}>
            Reload page
        </Button>
        <Button
          color="secondary"
          onClick={handlerCopyError}
          variant="contained">
            Copy Error for Support
        </Button>
      </div>
    </div>
  )
}

export default ErrorView

